import script from "./DocumentManagementView.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentManagementView.vue?vue&type=script&setup=true&lang=js"

import "./DocumentManagementView.vue?vue&type=style&index=0&id=59bf3f86&scoped=true&lang=css"
import "./DocumentManagementView.vue?vue&type=style&index=1&id=59bf3f86&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59bf3f86"]])

export default __exports__